import qs from "qs";
import request from "@/utils/api/helpers";

const approverMapBaseUrl = "/workflow/approver-workflow-maps";
const approverAssignmentBaseUrl = "/workflow/approver-assignments";

export const getApprovalMaps = (params = {}) => {
  const headers = {
    includeCompanyId: true,
  };

  const { companyId, includeCompanyId, ...rest } = params;

  if (typeof includeCompanyId === "boolean" && !includeCompanyId) {
    headers.includeCompanyId = false;
  }

  if (headers.includeCompanyId && companyId) {
    headers.Companyid = params.companyId;
  }

  const queryParams = qs.stringify(rest, {
    addQueryPrefix: true,
  });

  return request({
    url: `${approverMapBaseUrl}${queryParams}`,
    headers,
  });
};

export const getApprovalMapById = (id) =>
  request({
    url: `${approverMapBaseUrl}/${id}`,
  });

export const createApprovalMap = (data) =>
  request({
    url: approverMapBaseUrl,
    method: "POST",
    data,
  });

export const updateApprovalMap = (id, data) =>
  request({
    url: `${approverMapBaseUrl}/${id}`,
    method: "PATCH",
    data,
  });

export const deleteApprovalMap = (id) =>
  request({
    url: `${approverMapBaseUrl}/${id}`,
    method: "DELETE",
  });

export const getApprovalAssignments = (params = {}) => {
  const headers = {
    includeCompanyId: true,
  };

  const { companyId, includeCompanyId, ...rest } = params;

  if (typeof includeCompanyId === "boolean" && !includeCompanyId) {
    headers.includeCompanyId = false;
  }

  if (headers.includeCompanyId && companyId) {
    headers.Companyid = params.companyId;
  }

  const queryParams = qs.stringify(rest, {
    addQueryPrefix: true,
  });

  return request({
    url: `${approverAssignmentBaseUrl}${queryParams}`,
    headers,
  });
};

export const getApprovalAssignmentById = (id) =>
  request({
    url: `${approverAssignmentBaseUrl}/${id}`,
  });

export const createApprovalAssignment = (data) =>
  request({
    url: approverAssignmentBaseUrl,
    method: "POST",
    data,
  });

export const updateApprovalAssignment = (id, data) =>
  request({
    url: `${approverAssignmentBaseUrl}/${id}`,
    method: "PATCH",
    data,
  });

export const deleteApprovalAssignment = (id) =>
  request({
    url: `${approverAssignmentBaseUrl}/${id}`,
    method: "DELETE",
  });
